/* global $ */
import React, { Component } from 'react';
import {DetailsState} from './DetailsState';
import {BrandingState}  from './BrandingState';
import {CompleteState} from './CompleteState';
import {SettingsState} from './SettingsState';
import {LanguageSwitcher} from './LanguageSwitcher';
import {FAQLink} from './FAQLink';
import { config } from '../config.js';

class RegistrationState extends Component {
    constructor(props) {
        super(props);

        this.submitRegistration = this.submitRegistration.bind(this);
    };

    submitRegistration(target) {
        // Handle via ajax submitting the user data, upon
        // success return this.nextStop(). If it fails,
        // show the user the error but don't advance
        if (typeof target === 'string') {
            target = parseInt(target);
        }

        var token = this.props.accessToken;
        var accountId = this.props.accountId;
        var portalId = this.props.portalId;
        // Get values from session if we have refreshed the page, because we lost them
        if (accountId == undefined) {
            accountId = sessionStorage.getItem('accountId');
            token = sessionStorage.getItem('token');
            portalId = sessionStorage.getItem(portalId);
        }
        var paramsObject = {};
        function addParam(paramsObject, key, value) {
            paramsObject[key] = value;
        }
        function addNullableParam(paramsObject, key, value) {
            if (value === "" || typeof value === "undefined") {
                value = null;
            }
            paramsObject[key] = value;
        }
        function addNotRequiredParam(paramsObject, key, value) {
            if (!(value === "" || typeof value === "undefined")) {
                paramsObject[key] = value;
            }
        }
        addNullableParam(paramsObject, "businessName", this.props.fieldValues["businessName"]);
        addNullableParam(paramsObject, "businessType", this.props.fieldValues["businessType"]);
        addNullableParam(paramsObject, "serviceName", this.props.fieldValues["serviceName"]);
        addNullableParam(paramsObject, "facebookLink", this.props.fieldValues["facebookLink"]);
        addNullableParam(paramsObject, "twitterLink", this.props.fieldValues["twitterLink"]);
        addNullableParam(paramsObject, "foursquareLink", this.props.fieldValues["foursquareLink"]);
        addNullableParam(paramsObject, "redirectUrl", this.props.fieldValues["redirectUrl"]);
        addNullableParam(paramsObject, "adImage", this.props.fieldValues["adImage"]);

        var subscriptionTime = this.props.fieldValues["subscriptionTime"];
        if (subscriptionTime === "nolimit") {
            subscriptionTime = null;
        }
        var style = this.props.fieldValues["style"];
        if (style === "noimage") {
            style = null;
        }
        addNullableParam(paramsObject, "subscriptionTime", subscriptionTime);
        addNotRequiredParam(paramsObject, "style", style);
        $.ajax({
        url: config.cbuServiceUrl + '/customer/' + accountId + '/' + portalId + '/settings',
        method: 'PUT',
        dataType: 'json',
        jsonp: false,
        contentType: 'application/json',
        data: JSON.stringify(paramsObject),
        crossDomain: true,
        cache: false,
        beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
        },
        success: function(data) {
            this.props.setSaved(true);
            this.props.setBusinessName(this.props.fieldValues["businessName"]);
            if (target == 0) {
                $('#savedMessage .content p').html(this.props.showMessage('message_9_05'));
                $('#savedMessage .actions .ui.button').text(this.props.showMessage('message_9_06'));
                $('#savedMessage').modal('show');
            } else if (target == 1) {
                window.location = "https://manage.odyssys.net/login";
            }
        }.bind(this),
        error: function(xhr, status, err) {
            console.error(this.props.url, status, err.toString());
            this.props.setSaved(false);
            if (target == 0) {
                $('#errorMessage .content p').html(this.props.showMessage('message_9_07'));
                $('#errorMessage .actions .ui.button').text(this.props.showMessage('message_9_08'));
                $('#errorMessage').modal('show');
            } else if (target == 1) {
                $('#redirectErrorMessage .content p').html(this.props.showMessage('message_10_06'));
                $('#redirectErrorMessage .actions .ui.button').text(this.props.showMessage('message_10_07'));
                $('#redirectErrorMessage').modal('show');
            }
        }.bind(this)
        });
    };

    clearClasses() {
        $('#progress').removeClass();
        $('#progress').addClass('progress');
        $('#step_25').removeClass();
        $('#step_50').removeClass();
        $('#step_75').removeClass();
        $('#step_100').removeClass();
    }

    showStep() {
        // eslint-disable-next-line
        var accountId = this.props.accountId;
        var token = this.props.accessToken;
        // Get values from session if we have refreshed the page, because we lost them
        if (accountId == undefined) {
            accountId = sessionStorage.getItem('accountId');
            token = sessionStorage.getItem('token');
        }

        switch (this.props.step) {
            case 1:
                this.clearClasses();
                $('#progress').addClass('step_25');
                $('#step_25').addClass('selected');
                return <DetailsState ref="detailsComponent"
                                     accessToken={token}
                                     accountId={accountId}
                                     fieldValues={this.props.fieldValues}
                                     nextStep={this.props.nextStep}
                                     skipSettings={this.props.skipSettings}
                                     setSaved={this.props.setSaved}
                                     setSkipped={this.props.setSkipped}
                                     previousStep={this.props.previousStep}
                                     saveValues={this.props.saveValues}
                                     changeLang={this.props.changeLang}
                                     lang={this.props.lang}
                                     showMessage={this.props.showMessage} />;
            case 2:
                this.clearClasses();
                $('#progress').addClass('step_50');
                $('#step_50').addClass('selected');
                return <SettingsState ref="settingsComponent"
                                      fieldValues={this.props.fieldValues}
                                      nextStep={this.props.nextStep}
                                      previousStep={this.props.previousStep}
                                      isSettingsSkipped={this.props.isSettingsSkipped}
                                      saveValues={this.props.saveValues}
                                      changeLang={this.props.changeLang}
                                      lang={this.props.lang}
                                      showMessage={this.props.showMessage} />;
            case 3:
                this.clearClasses();
                $('#progress').addClass('step_75');
                $('#step_75').addClass('selected');
                return <BrandingState ref="brandingComponent"
                                      fieldValues={this.props.fieldValues}
                                      nextStep={this.props.nextStep}
                                      previousStep={this.props.previousStep}
                                      saveValues={this.props.saveValues}
                                      changeLang={this.props.changeLang}
                                      lang={this.props.lang}
                                      showMessage={this.props.showMessage}
                                      imagePreviewContainerDisplay={this.props.imagePreviewContainerDisplay}
                                      imageUploadFormContainer={this.props.imageUploadFormContainer}
                                      setImagePreviewContainerDisplay={this.props.setImagePreviewContainerDisplay}
                                      setImageUploadFormContainer={this.props.setImageUploadFormContainer}
                                      backgroundImagePreviewContainerDisplay={this.props.backgroundImagePreviewContainerDisplay}
                                      backgroundImageUploadFormContainer={this.props.backgroundImageUploadFormContainer}
                                      setBackgroundImagePreviewContainerDisplay={this.props.setBackgroundImagePreviewContainerDisplay}
                                      setBackgroundImageUploadFormContainer={this.props.setBackgroundImageUploadFormContainer}
                                      accessToken={token}
                                      accountId={accountId} />;
            case 4:
                this.clearClasses();
                $('#progress').addClass('step_100');
                $('#step_100').addClass('selected');
                return <CompleteState ref="completeComponent"
                                      fieldValues={this.props.fieldValues}
                                      submitRegistration={this.submitRegistration}
                                      changeLang={this.props.changeLang}
                                      lang={this.props.lang}
                                      showMessage={this.props.showMessage}
                                      isSettingsSkipped={this.props.isSettingsSkipped}
                                      isSaved={this.props.isSaved}
                                      showLogin={this.props.showLogin}/>;
        }
    };

    render() {
        return (
            <div id="wizardContainer">
                <div id="control" className="purpleBgd">
                    <button className="reset" onClick={this.props.handleResetOpen}><i className="undo button icon"></i>{this.props.showMessage('message_4_01')}</button>
                    <div>
                        {/*<FAQLink showFAQ={this.props.showFAQ} />*/}
                        <LanguageSwitcher changeLang={this.props.changeLang}
                                          lang={this.props.lang} />
                    </div>
                </div>
                <div id="content">
                    <div id="progress" className="progress step_25">
                        <div>
                            <div>
                                <span className="selected" id="step_25">{this.props.showMessage('message_4_02')}</span>
                            </div>
                            <div>
                                <span id="step_50">{this.props.showMessage('message_4_03')}</span>
                            </div>
                            <div>
                                <span id="step_75">{this.props.showMessage('message_4_04')}</span>
                            </div>
                            <div>
                                <span id="step_100">{this.props.showMessage('message_4_05')}</span>
                            </div>
                        </div>
                    </div>
                    {this.showStep()}
                </div>
            </div>
        )
    };
};

export default RegistrationState;



// WEBPACK FOOTER //
// ./src/components/RegistrationState.jsx